<!-- 聊天列表 -->
<template>
  <div class="left-user">
      <div class="left-top-search">
            <el-input :style="otherSys === 'ris' && pageType === '1' ? 'width: calc(100% - 90px);':'width:100%'" prefix-icon="el-icon-search" size="mini" id="filter-users" clearable v-model="filterText" class="inline-block" placeholder="搜索" @input="filterUserChange"/>
            <el-select v-if="otherSys === 'ris' && pageType === '1'" style="width: 85px;" v-model="team" size="mini" @change="filterUserChange">
              <el-option label="诊断组" value="诊断组"></el-option>
              <el-option label="技术组" value="技术组"></el-option>
              <el-option label="护理组" value="护理组"></el-option>
              <el-option label="群聊" value="群聊"></el-option>
              <el-option label="在线" value="在线"></el-option>
              <el-option label="未读消息" value="未读消息"></el-option>
            </el-select>
        </div>
        <div class="user-list">
            <div class="user-list-title">
                <span>消息列表</span>
                <el-dropdown trigger="click" class="dropdown add-icon pull-right" @command="command">
                    <span>
                        <div class="iconfont icon-xinzeng cursor" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="addGroup">加入群</el-dropdown-item>
                        <el-dropdown-item command="createGroup" v-if="pageType === '1'">创建群</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <ul id="allUserList" class="padding-0 mg-0 border-bottom">
                <div v-for="(item,index) in allList" :key="index">
                    <li v-if="item.type === 0" :class="['border-bottom','name-li',item.isOnline ? '':'unlive',item.isClick ? 'active':'']"  @click="getChart(0,item)">
                        <img :src="item.user.avatarImageUrl ? item.user.avatarImageUrl : require('../../../static/avatar.jpg')"/>
                        <div v-if="item.hasUnReadLog"  class="message-circle">
                            <span>{{item.unReadLogCount > 99 ? 99:item.unReadLogCount}}</span>
                        </div>
                        <div class="name-content">
                                <div class="name-time-box">
                                    <span class="name ellipse inline-block">{{item.user.userName}}<span v-if="otherSys === 'ris'&& pageType === '1'" style="font-size:12px;margin-left: 5px;">{{item.isOnline ? '[在线]':'[离线]'}}</span></span>
                                    <span class="time">{{getChatTimeAndContent(item.lastChat,false).createdTime}}</span>
                                </div>
                                <div class="content ellipse" v-html="getChatTimeAndContent(item.lastChat,false).content"></div>
                        </div>
                    </li>
                    <li v-else :class="['border-bottom',item.isClick ? 'active':'','name-li',item.groupStatus === 2 ? 'closed':'']" :key="index" @click="getChart(1,item)">
                        <div>
                            <div class="group-img">{{item.groupName.substring(0,1)}}</div>
                            <div v-if="item.hasUnReadLog"  class="message-circle">
                                <span>{{item.unReadLogCount > 99 ? 99:item.unReadLogCount}}</span>
                            </div>
                        </div>
                        <div class="name-content">
                            <div class="name-time-box">
                                <span class="name ellipse inline-block">{{item.groupName}}</span>
                                <span class="time">{{getChatTimeAndContent(item.lastChat,true,item.users).createdTime}}</span>
                            </div>
                            <div class="content ellipse" v-html="getChatTimeAndContent(item.lastChat,true,item.users).content"></div>
                        </div>
                    </li>
                </div>
            </ul>
        </div>
       <!--  <div class="group-list">
            <div class="user-list-title bd-top">
                <span>群组列表</span>
                <el-dropdown class="dropdown add-icon pull-right" @command="command">
                    <span>
                        <div class="iconfont icon-xinzeng cursor" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="addGroup">加入群</el-dropdown-item>
                        <el-dropdown-item command="createGroup" v-if="pageType === '1'">创建群</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <ul id="allChatGroupList" class="padding-0 mg-0">
                <li :class="['border-bottom',item.isClick ? 'active':'','name-li']" v-for="(item,index) in allGroupsShowData" :key="index" @click="getChart(1,item)">
                    <div>
                        <div class="group-img">{{item.groupName.substring(0,1)}}</div>
                        <div class="message-circle" v-show="item.hasUnReadLog"></div>
                    </div>
                    <div class="name-content">
                        <div class="name-time-box">
                            <span class="name ellipse inline-block">{{item.groupName}}</span>
                            <span class="time">{{getChatTimeAndContent(item.lastChat,true).createdTime}}</span>
                        </div>
                        <div class="content ellipse" v-html="getChatTimeAndContent(item.lastChat,true).content"></div>
                    </div>
                </li>
            </ul>
        </div> -->
  </div>
</template>

<script>
import {setReadMsg} from '../../api/api.js'
import emojis from '../../assets/emojis.json'
export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    myUserId: {
      type: String,
      default: ''
    },
    pageSize: {
      type: String,
      default: 'big'
    },
    allUserGroups: {
      Object,
      default: () => {}
    },
    otherSys: {
      String,
      default: ''
    },
    clickItem: {
      Object,
      default: () => {}
    },
    pageType: {
      String,
      default: '1'
    }
  },
  data () {
    return {
      allUsers: [],
      allGroups: [],
      allUsersShowData: [],
      allGroupsShowData: [],
      mySelfData: {},
      filterText: '',
      allList: [],
      allOriginalList: [],
      canGetNext: true,
      team: '诊断组'// 组别
    }
  },
  watch: {
    allUserGroups: {
      handler (val, oldVal) {
        if (val.allGroups || val.allUsers) {
          /*  if (val.allGroups) {
            this.setGroupListDiv()
          }
          if (this.allUserGroups.allUsers) {
            this.allUsers = JSON.parse(JSON.stringify(this.allUserGroups.allUsers))
            this.dealAllUserForList()
          } */
          this.allUsers = JSON.parse(JSON.stringify(this.allUserGroups.allUsers))
          if (this.pageType === '1') { // 普通登录--显示普通组和人消息
            let obj = this.allUserGroups.allGroups.find(res => {
              return res.groupType === 'Simple'
            })
            let groups = (obj && obj.groups) || []
            let list = groups.concat(this.allUserGroups.allUsers || [])
            this.dealAllList(list)
          } else if (this.pageType === '2') { // RIS登录--只显示ris的组
            let obj = this.allUserGroups.allGroups.find(res => {
              return res.groupType === 'RIS'
            })
            let list = (obj && obj.groups) || []
            this.dealAllList(list)
          }
          this.filterUserChange()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    getUseList (params) {
      return new Promise(async (resolve, reject) => {
        if (this.canGetNext) {
          this.canGetNext = false
          /* await getChartData(params).then(data => {
            if (data && data.length > 0) {
              this.lastContentTime = data[0].createdTime
              this.tempArr = []
              this.tempImgList = []
              data.forEach((el, i) => {
                if (i === 0) {
                  this.setChatListFunc(el, false, true)
                } else {
                  this.setChatListFunc(el, false, false)
                }
              })
              this.chatList = this.tempArr.concat(this.chatList)
              this.imgList = this.tempImgList.concat(this.imgList)
              this.height1 = document.getElementById('allUserList').scrollHeight
              resolve()
            }
          }).finally(() => {
            this.canGetNext = true
          }) */
        }
      })
    },
    dealAllList (list) { // 处理全部列表数据，加type,按最后接收的时间排序，并过滤出自己本人
      let arr = []
      let closedGroup = []
      for (let i = 0; i < list.length; i++) {
        if (list[i].groupId) { // 群组
          list[i].type = 1
          list[i].isClick = false
          if (list[i].groupStatus === 2) {
            closedGroup.push(list[i])
          } else {
            arr.push(list[i])
          }
        } else { // 单聊
          list[i].type = 0
          list[i].isClick = false
          list[i].isOnline = false
          if (list[i].user.id !== this.myUserId) {
            arr.push(list[i])
          }
        }
      }
      closedGroup.sort((a, b) => { // 排序
        if (a.lastChat && b.lastChat) {
          return this.$dayjs(b.lastChat.createdTime).diff(a.lastChat.createdTime)
        } else if (!a.lastChat) {
          return 1
        } else if (!b.lastChat) {
          return -1
        }
      })

      arr.sort((a, b) => { // 排序
        if (a.lastChat && b.lastChat) {
          return this.$dayjs(b.lastChat.createdTime).diff(a.lastChat.createdTime)
        } else if (!a.lastChat) {
          return 1
        } else if (!b.lastChat) {
          return -1
        }
      })
      arr = arr.concat(closedGroup)
      //   this.allList = arr
      this.allOriginalList = JSON.parse(JSON.stringify(arr))
    },
    setGroupListDiv () {
      let obj = {}
      if (this.allUserGroups.allGroups && this.pageType === '1') {
        obj = this.allUserGroups.allGroups.find(res => {
          return res.groupType === 'Simple'
        })
      } else if (this.allUserGroups.allGroups && this.pageType === '2') {
        obj = this.allUserGroups.allGroups.find(res => {
          return res.groupType === 'RIS'
        })
      }
      if (obj && obj.groups) {
        this.allOriginalList = JSON.parse(JSON.stringify(obj.groups))
        // this.allGroupsShowData = this.allGroups
      }
    },
    changeGroups (data, unEnter) {
      if (data.type === 0) { // 新增
        let obj = data.changeGroup
        if (obj.groupType === Number(this.pageType)) {
          this.$set(obj, 'isClick', true)
          data.changeGroup.type = 1
          this.allOriginalList.unshift(data.changeGroup)
        }
        this.filterUserChange()
        if (!unEnter) { // 不进入群聊
          this.getChart(1, obj)
        }
      } else if (data.type === 1) {
        if (data.changeGroup.groupStatus === 2) { // 关闭会话--改状态
          this.allOriginalList.forEach(v => {
            if (v.type === 1 && v.groupId === data.changeGroup.groupId) { // 群
              v.groupStatus = 2
            }
          })
          this.filterUserChange()
        }
        if (data.changeGroup.groupId === this.clickItem.id) {
          // 是当前点击的组并且打开了群管理。需要重新刷新一下群管理数据
          this.$emit('changeGroupSetting')
          this.clickItem.groupStatus = data.changeGroup.groupStatus
          this.$emit('update:clickItem', this.clickItem)
        }
      } else if (data.type === 2 && data.changeGroup.groupType === Number(this.pageType)) { // 删除
        let index = this.allOriginalList.findIndex(v => {
          return data.changeGroup.groupId === v.groupId
        })
        this.allOriginalList.splice(index, 1)
        this.filterUserChange()
        if (this.clickItem.id === data.changeGroup.groupId) {
          this.$emit('changeGroupDelete')// 如果删除的组是正在展示的组，那就清空显示的东西
        }
      }
    },
    getChart (type, val) {
      // 把被点击的人存下来,并设置点击样式 0：单聊，1：群聊
      let clickItem = {
        type,
        id: type === 0 ? val.user.id : val.groupId,
        name: type === 0 ? val.user.userName : val.groupName,
        avatarImageUrl: type === 0 ? val.user.avatarImageUrl : null,
        questNum: type === 0 ? null : val.questNum,
        groupStatus: type === 0 ? null : val.groupStatus,
        groupType: type === 0 ? null : val.groupType,
        users: type === 0 ? null : val.users,
        updateTime: type === 0 ? null : val.updateTime
      }
      this.$emit('update:clickItem', clickItem)// 更新clickItem
      window.localStorage.setItem('clickItem', JSON.stringify(clickItem))
      this.setActive(clickItem)
      this.$nextTick(() => {
        if (val.hasUnReadLog) { // 有未读消息就设置已读
          this.setReadMsgToAPI().then(res => {
            this.$set(val, 'hasUnReadLog', false)
            this.$set(val, 'unReadLogCount', 0)
          })
        }
      })

      this.$emit('chatClick', clickItem)
    },
    setActive (clickItem) {
      /* if (clickItem.type === 0) { // 单聊
        for (const v of this.allUsers) {
          if (v.user.id === clickItem.id) {
            this.$set(v, 'isClick', true)
            // v.isClick = true
          } else {
            // v.isClick = false
            this.$set(v, 'isClick', false)
          }
        }
        for (const v of this.allGroups) {
        //   v.isClick = false
          this.$set(v, 'isClick', false)
        }
      } else { // 群组
        for (const v of this.allUsers) {
        //   v.isClick = false
          this.$set(v, 'isClick', false)
        }
        for (const v of this.allGroups) {
          if (v.groupId === clickItem.id) {
            // v.isClick = true
            this.$set(v, 'isClick', true)
          } else {
            // v.isClick = false
            this.$set(v, 'isClick', false)
          }
        }
      } */
      for (const v of this.allOriginalList) {
        this.$set(v, 'isClick', false)
        if (clickItem.type === v.type && (v.groupId === clickItem.id || (v.user && v.user.id === clickItem.id))) {
          this.$set(v, 'isClick', true)
        }
      }
    },
    appendCircle (type, id) {
      // 添加未读红色点
      /* if (type === 'user') { // 个人
        for (let i = 0; i < this.allUsers.length; i++) {
          let item = this.allUsers[i]
          if (item.user.id === id) {
            item.hasUnReadLog = true// 设置红色标点
            break
          }
        }
      } else { // 群
        for (let i = 0; i < this.allGroups.length; i++) {
          let item = this.allGroups[i]
          if (item.groupId === id) {
            item.hasUnReadLog = true// 设置红色标点
            break
          }
        }
      } */

      for (let i = 0; i < this.allOriginalList.length; i++) {
        let item = this.allOriginalList[i]
        if (type === 'user') { // 单聊
          if (item.type === 0 && item.user.id === id) {
            item.unReadLogCount++// 设置红色标点
            item.hasUnReadLog = true
            break
          }
        } else { // 群聊
          if (item.type === 1 && item.groupId === id) {
            item.unReadLogCount++// 设置红色标点
            item.hasUnReadLog = true
            break
          }
        }
      }

      this.sortList(type, id)
    },
    sortList (type, id) {
      /* if (type === 'user') { // 个人
        for (let i = 0; i < this.allUsers.length; i++) {
          let item = this.allUsers[i]
          if (item.user.id === id) {
            this.allUsers.splice(i, 1)
            this.allUsers.unshift(item)// 把对话框前移
            break
          }
        }
      } else { // 群
        for (let i = 0; i < this.allGroups.length; i++) {
          let item = this.allGroups[i]
          if (item.groupId === id) {
            this.allGroups.splice(i, 1)
            this.allGroups.unshift(item)// 把对话框前移
            break
          }
        }
      } */

      for (let i = 0; i < this.allOriginalList.length; i++) {
        let item = this.allOriginalList[i]
        if (type === 'user') { // 单聊
          if (item.type === 0 && item.user.id === id) {
            this.allOriginalList.splice(i, 1)
            this.allOriginalList.unshift(item)// 把对话框前移
            break
          }
        } else { // 群聊
          if (item.type === 1 && item.groupId === id) {
            this.allOriginalList.splice(i, 1)
            this.allOriginalList.unshift(item)// 把对话框前移
            break
          }
        }
      }

      this.filterUserChange()
    },
    command (val) {
      if (val === 'addGroup') { // 加入群
        this.$emit('addGroup')
      } else if (val === 'createGroup') { // 创建群
        this.$emit('createGroup')
      }
    },
    getChatTimeAndContent (lastChat, flag, users) { // flag:false单聊。true:群聊
      let obj = {
        createdTime: '',
        content: ''
      }
      if (lastChat) {
        if (lastChat.createdTime) {
          let dayType = this.$chatUtils.judgeTime(lastChat.createdTime)
          if (dayType === 0) { // 今天显示时间
            obj.createdTime = lastChat.createdTime.substring(11, 16)
          } else if (dayType === 1) {
            obj.createdTime = '昨天'
          } else if (dayType === 2) {
            obj.createdTime = '前天'
          } else if (dayType === 3) { // 显示月日
            obj.createdTime = lastChat.createdTime.substring(5, 10)
          } else { // 其余显示年月日加时间
            obj.createdTime = lastChat.createdTime.substring(0, 10)
          }
        }
        if (lastChat.chatType || lastChat.chatType === 0) {
          if (flag && lastChat.chatType !== 5) { // 群消息，需要添加发送人名字
            /* if (lastChat.sendUserId && this.allUsers && this.allUsers.length > 0) {
              let item = this.allUsers.find(res => {
                return res.user.id === lastChat.sendUserId
              })
              obj.content = item.user.userName + ':'
            } else {
              obj.content = lastChat.sendUser.userName + ':'
            } */
            obj.content = users[0].userName + ':'
          } else if (flag && lastChat.chatType === 5) {
            obj.content = '群消息:'
          }
          if (lastChat.chatType === 1) {
            obj.content += '[图片]'
          } else if (lastChat.chatType === 2) {
            obj.content += '[文件]'
          } else if (lastChat.chatType === 3) {
            obj.content += '[评论]'
          } else if (lastChat.chatType === 4) {
            obj.content += '[语音]'
          } else if (lastChat.chatType === 6) {
            obj.content += '[视频通话]'
          } else if (lastChat.chatType === 7) {
            obj.content += '[患者病历]'
          } else if (lastChat.chatType === 8) {
            obj.content += '[功能应用]'
          } else {
            let str = this.strToEmoji(lastChat.content)
            obj.content += str
          }
        }
      }
      return obj
    },
    strToEmoji (val) { // 表情转换编码
      for (const key in emojis) {
        // eslint-disable-next-line no-undef
        const el = emojis[key]
        // val = val.replaceAll(el.keywords, el.char)
        let reg = new RegExp(el.keywords, 'g')
        val = val.replace(reg, el.char)// 去除掉回车带来的换行
      }
      return val
    },
    dealAllUserForList () { // 筛选出自己和其他人的数据
      this.allUsersShowData = []
      this.allUsers.forEach(el => {
        if (el.user.id !== this.myUserId) {
          this.allUsersShowData.push(el)
        }
      })
    },
    onlineUserChange (data) {
      /* // 先全置为下线
      for (let val of this.allUsersShowData) {
        this.$set(val, 'isOnline', false)
      }
      // 设置上线的人
      for (let item of data.onlineUsers) {
        for (let val of this.allUsersShowData) {
          if (item === val.user.id) {
            this.$set(val, 'isOnline', true)
            this.sortList('user', item)
          }
        }
      } */
    //   if (this.allOriginalList) {
      for (let val of this.allOriginalList) {
        this.$set(val, 'isOnline', false)
        for (let item of data.onlineUsers) {
          if (val.type === 0 && item === val.user.id) {
            this.$set(val, 'isOnline', true)
            this.sortList('user', item)// 上线的人不排序了
            this.filterUserChange()
          }
        }
      }
      //   }
      this.$forceUpdate()
    },
    async setReadMsgToAPI () { // 设置已读
      let params = {
        userId: this.myUserId,
        otherId: this.clickItem.id,
        type: this.clickItem.type,
        // eslint-disable-next-line no-undef
        startTime: this.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        pageSize: 0
      }
      await setReadMsg(params)
    },
    updateLastMsg (type, id, message) { // 列表更新最新消息
      /* if (type === 'user') {
        let obj = this.allUsers.find(res => {
          return res.user.id === id
        })
        if (obj) {
          obj.lastChat = {
            chatReceiveType: message.chatReceiveType,
            chatType: message.chatType,
            content: message.content,
            createdTime: message.createdTime,
            id: message.messageId,
            receiveUserId: message.groupId,
            sendUserId: message.sendUser.id
          }
        }
      } else {
        let obj = this.allGroups.find(res => {
          return res.groupId === id
        })
        if (obj) {
          obj.lastChat = {
            chatReceiveType: message.chatReceiveType,
            chatType: message.chatType,
            content: message.content,
            createdTime: message.createdTime,
            id: message.messageId,
            receiveUserId: message.groupId,
            sendUserId: message.sendUser.id
          }
        }
      } */
      let obj = this.allOriginalList.find(res => {
        if (type === 'user' && res.type === 0 && res.user.id === id) {
          return true
        } else if (type === 'group' && res.type === 1 && res.groupId === id) {
          return true
        } else {
          return false
        }
      })
      if (obj) {
        obj.lastChat = {
          chatReceiveType: message.chatReceiveType,
          chatType: message.chatType,
          content: message.content,
          createdTime: message.createdTime,
          id: message.messageId,
          receiveUserId: message.groupId,
          sendUserId: message.sendUser && message.sendUser.id
        //   sendUser: message.sendUser
        }
        obj.users = [message.sendUser]// 最后一条发送方的users
      }
    },
    filterUserChange () { // 搜索过滤人员
      console.log('this.allOriginalList........', this.allOriginalList)
      this.allList = this.allOriginalList.filter(el => {
        if (el.type === 0) { // 单聊
          return el.user.userName.indexOf(this.filterText) > -1
        } else { // 群聊
          return el.groupName.indexOf(this.filterText) > -1
        }
      })
      if (this.otherSys === 'ris' && this.pageType === '1') {
        this.allList = this.allList.filter(el => {
          if (el.type === 0) { // 单聊
            if (this.team === '在线') {
              return el.isOnline
            } else if (this.team === '未读消息') { // ----显示有未读消息的单聊
              return el.hasUnReadLog
            } else {
              return el.user.team === this.team
            }
          } else if (this.team === '群聊') { // 群聊并且过滤项为群聊
            return true
          } else if (this.team === '未读消息') { // 群聊并且为未读消息过滤项---显示有未读消息的群聊
            return el.hasUnReadLog
          }
        })
      }
    }
  },
  beforeDestroy () {},
  destroyed () {},
  beforeUpdate () {},
  updated () {}
}
</script>
<style lang='scss' scoped>
.left-user{
    width: 300px;
    height: 100%;
    background: #fff;
    border-right:1px solid rgba(0,0,0,0.12);
    display: flex;
    flex-direction: column;
    .left-top-search{
        text-align: center;
        // border-bottom: 1px solid rgba(0,0,0,0.2);
        padding: 5px 14px;
        height: 44px;
        line-height: 44px;
        // .my-avatar-name{
        //     width: 54px;
        //     height: 44px;
        //     display: flex;
        //     flex-direction: column;
        //     align-items: center;
        //     justify-content: space-evenly;
        //     float: left;
        // }
        // .my-avatar-name img{
        //     width: 28px;
        //     border-radius: 5px;
        // }
        // .my-avatar-name span{
        //     font-size: 12px;
        //     line-height: 12px;
        // }
    }
    .user-list,.group-list{
        height: calc(50% - 28px);
        flex: 1;
    }
    .user-list,.group-list{

        .user-list-title{
            height: 23px;
            box-sizing: content-box;
            padding: 14px;
            line-height: 23px;
            border-bottom: 1px solid #EBEBEB;
            background: rgba(242, 243, 245, 1);
        }
        ul{
            height: calc(100% - 55px);
            overflow: auto;
            padding:0px;
            li{
                padding: 12px 14px;
                cursor: pointer;
                img{
                    width: 44px;
                    height:44px;
                    margin-right: 10px;
                    border-radius: 5px;
                }
            }
            .unlive .name,.unlive .content{
                color: #999999!important;
            }
            .closed .name,.closed .content{
                color: #999999!important;
            }
            .closed{
                background: #efefef;
            }
            .name-li{
                position: relative;
                display: flex;
                align-items: center;
                > .name-content{
                    width: calc(100% - 54px);
                    line-height: 19px;
                    height: 38px;
                }
                .name-time-box{
                    display: flex;
                    justify-content: space-between;
                }
                .name{
                    color: #1D2129;
                    font-weight: 600;
                }
                .time{
                    font-size: 12px;
                    // float: right;
                    color: #86909C;
                    text-align: right;
                    flex-shrink: 0;
                    margin-left: 5px;
                }
                .content{
                    color: #4E5969;
                    font-size: 12px;
                    max-width: calc(100vw - 91px);
                }
            }
            .border-bottom{
                // border-bottom: 1px solid #dddddd61;
            }
        }
    }
    .active{
        background: rgba(255, 125, 0, 0.08)!important;
    }
    .active::before{
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0px;
        width: 4px;
        height: 67px;
        // background: #FF7D00;
    }
    .message-circle{
        width: 30px;
        height: 18px;
        line-height: 18px;
        border-radius: 10px;
        background-color: #F53F3F;
        position: absolute;
        text-align: center;
        bottom: 13px;
        right: 13px;
        span{
            color: #fff;
            // font-weight: 600;
            font-size: 14px;
        }
    }

    /deep/ .el-input--mini .el-input__inner{
        background: rgba(242, 243, 245, 1);
        border: 1px solid rgba(0,0,0,0.1);
    }
    .group-img{
        width: 44px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        // background: #FF7D00;
        float: left;
        border-radius: 20%;
        margin-right: 10px;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// packages/chat/src/chat-list.vue